import styled from "styled-components";
import { COLOUR_CONSTANT } from "../../../../utils/contants";

export const ProjectTableStyled = styled.div`
  .table-wrapper {
    margin: 0 !important;
  }

  .full-height {
    .MuiPaper-root {
      overflow-y: auto;
      height: calc(-200px + 100vh);
    }
  }

  .projects-table{
    padding: 12px 36px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

    thead {
      tr {
        & th:nth-child(1) {
          position: sticky !important;
          left: 0;
          opacity: 1;
          z-index: 3;
        }
        & th:nth-child(2) {
          position: sticky !important;
          left: 80px;
          opacity: 1;
          z-index: 3;
          background-color: red;
        }
        & th:nth-last-child(1) {
          position: sticky !important;
          right: 0;
          opacity: 1;
          z-index: 3;
          background-color: white;
        }
      }
    }
    tbody {
      tr {
        & td:nth-child(1) {
          position: sticky !important;
          left: 0;
          z-index: 2;
          opacity: 1;
          background-color: ${COLOUR_CONSTANT.theme.purple.light};
        }

        & td:nth-child(2) {
          position: sticky !important;
          left: 80px;
          z-index: 2;
          opacity: 1;
          background-color: ${COLOUR_CONSTANT.theme.purple.light};
        }
        & td:nth-last-child(1) {
          position: sticky !important;
          right: 0;
          z-index: 2;
          opacity: 1;
          background-color: white;
          padding: 0 !important;
        }
      }
    }

`;
